<template>
  <div v-if="authenticatedUser">
    <v-navigation-drawer
      :value="drawer"
      fixed
      app
      width="256"
      mobile-breakpoint="960"
      class="main-nav"
      @input="setDrawer"
    >
      <template v-slot:prepend>
        <div class="avatar-container secondary">
          <v-list-item two-line>
            <v-img
              v-if="tenantNameMap[currentTenant.id] === 'Baker Book House'"
              src="/logo-light.svg"
              alt="logo"
              max-width="150"
              contain
            />

            <v-img
              v-if="tenantNameMap[currentTenant.id] === 'Baker Academic'"
              alt="logo"
              style="transform: translateY(8px)"
              max-width="200"
              contain
              src="/baker-academic-logo-light.svg"
            />
          </v-list-item>
          <v-menu
            v-if="currentTenant"
            v-model="menuOpen"
            offset-y
            transition="slide-y-transition"
            bottom
            right
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-list-item
                v-bind="attrs"
                class="account-menu"
                v-on="on"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text--white">
                    {{ currentTenant.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text--white">
                    {{ authenticatedUser.userProfile.fullName }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon
                    color="white"
                    :class="{active: menuOpen}"
                  >
                    mdi-menu-down
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item
                v-for="tenant in userTenants"
                :key="tenant.tenantId"
                :class="tenant.id === currentTenant.id ? 'active' : ''"
                @click="tenant.id !== currentTenant.id && switchTenant(tenant.id)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ tenant.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <v-list-item
                class="text--white"
                @click="clearSession"
              >
                <v-list-item-content>
                  <v-list-item-title>Sign Out</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <v-divider />
      <v-list dense>
        <div
          v-for="(grp, index) in groups"
          :key="index"
        >
          <v-subheader>{{ grp.groupText }}</v-subheader>
          <div
            v-for="item in getNavItems(grp.groupName)"
            :key="item.name"
          >
            <v-list-group
              v-if="item.meta.navChildren && canViewThis(item.meta)"
              :group="item.path"
              append-icon=""
              :value="item.path.includes($route.path)"
              no-action
              sub-group
              @click="$route.path !== item.path && $router.push(item.path)"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title
                    class="v-list-group-title-margin"
                  >
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="child in item.meta.navChildren"
                :key="child.name"
                :to="child.path"
                class="child-nav-item"
              >
                <v-list-item-title
                  v-text="child.name"
                />
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-if="!item.meta.navChildren && canViewThis(item.meta)"
              :to="item.path"
            >
              <v-list-item-icon>
                <v-icon>{{ item.meta.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { APP_ROUTES } from '@/router'
import { AUTH_TYPES } from '@/store/modules/auth'
import { LAYOUT_TYPES } from '../../store/modules/layout'
import { TenantNameMap } from '../../utils/helpers'

export default {
  name: 'TheMainNav',
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menuOpen: false,
      tenantNameMap: TenantNameMap,
      groups: [
        {
          "groupName": "global",
          "groupText": "Global"
        },
        {
          "groupName": "merchandising",
          "groupText": "Merchandising"
        },
        {
          "groupName": "promotion",
          "groupText": "Promotions"
        },
        {
          "groupName": "development",
          "groupText": "Development"
        },
        {
          "groupName": "settings",
          "groupText": "Settings"
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: AUTH_TYPES.getters.isAuthenticated,
      hasPermission: AUTH_TYPES.getters.hasPermission,
      currentTenant: AUTH_TYPES.getters.currentTenant,
      userTenants: AUTH_TYPES.getters.userTenants
    }),
    ...mapState({
      authenticatedUser: state => state.auth.authenticatedUser,
      drawer: state => state.layout.drawer
    })
  },
  methods: {
    ...mapActions({
      clearSession: AUTH_TYPES.actions.clearSession,
      switchTenant: AUTH_TYPES.actions.switchTenant
    }),
    ...mapMutations({
      setDrawer: LAYOUT_TYPES.mutations.SET_DRAWER
    }),
    getNavItems (groupName) {
      return APP_ROUTES.find(r => r.name === 'Base').children
        .filter(r => r.meta.group === groupName)
    },
    canViewThis (item) {
      let authorized = false
      if (item.permissions.length > 0) {
        item.permissions.forEach(routePermission => {
          if (this.hasPermission(routePermission)) {
            authorized = true
          }
        })
      }
      if (item.tenants && !item.tenants.includes(this.currentTenant.name)) {
        authorized = false
      }
      return authorized
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './src/styles/variables';

  .v-subheader {
    text-transform: uppercase;
    font-weight: bold
  }

  .v-icon.active {
    transform: rotate(-180deg);
  }

  .v-list-group--active {
    padding-bottom: 20px;
  }

  .account-menu .v-list-item__content .v-list-item__subtitle {
    color: #fff;
  }

  .v-list-group-title-margin {
    padding-left: 16px;
  }

  .child-nav-item {
    min-height: 30px !important;
    .v-list-item__title {
      padding-left: 56px;
    }
  }

</style>
